require('./accountsBuyAmazonGiftCardSuccess.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKLink } = require('commonsComponents/OKLink');
const AmazonGiftCardReedemptionSteps = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardReedemptionSteps/amazonGiftCardReedemptionSteps');
const AmazonGiftCardDetails = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardDetails/amazonGiftCardDetails');
const AmazonGiftCardImage = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardImage/amazonGiftCardImage');
//@commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { CANJEAR_CODIGO_LINK
} = require('constants/accountAmazonGiftCard');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
//@constants
const { 
    AMAZON_PROMOCIONES_STEP_THREE_SUCCESS,
    AMAZON_GIFT_CARD_TIPO_PROCESS
} = require('constants/tagging');
//@utils
const {
    recordPath
} = require("utilities/tagging");

class AccountsBuyAmazonGiftCardSuccess extends React.Component {

    componentDidMount() {
        recordPath(AMAZON_PROMOCIONES_STEP_THREE_SUCCESS, '', AMAZON_GIFT_CARD_TIPO_PROCESS, "paso 3/exito");
    }

    handleCopyIconClick = (e, giftCardClaimCode) => {
        e.preventDefault();
        sendTextToClipBoard(giftCardClaimCode);
        this.props.showNotification(formatText("amazonGiftCard-copySnackbarText"));
    }

    giftCardClaimCode() {
        const { accountBuyAmazonGiftCard } = this.props;
        let giftCardClaimCode = accountBuyAmazonGiftCard.get('giftCardClaimCode');
        return (
            <React.Fragment>
                <div className="accounts-buy-amazon-gift-card-success__claimcode">
                    {giftCardClaimCode}
                </div>
                <button
                    className="icon__tooltip icon-copiar accounts-buy-amazon-gift-card-success__copy-icon"
                    onClick={(e) => this.handleCopyIconClick(e, giftCardClaimCode)}
                >
                </button>
            </React.Fragment>
        );
    }

    render() {
        const { 
            accountBuyAmazonGiftCard, 
            handleVolverACuentasClick,
            immAccounts,
            immSteps,
        } = this.props;
        const goBackButtonLabel = <FormattedText value="buyAmazonGiftCardError-backToAccounts" format="uppercase"/>;
        const mainButton = {
            label: goBackButtonLabel
        };
        let giftCardClaimCode = this.giftCardClaimCode();
        const successTitle = <FormattedText value="amazonGiftCard-successtitle" />;
        let disclaimerText =(
            <div className="accounts-buy-amazon-gift-card-success__disclaimer-text">
                <OKMessage type="informative">
                    <FormattedText value="buyAmazonGiftCard-disclaimerText"
                    />
                </OKMessage>
            </div>
        );

        let successSubMessage = (
            <div className="accounts-buy-amazon-gift-card-success__content col-xs-12">
                <div className="accounts-buy-amazon-gift-card-success__content-card col-xs-5">
                    <AmazonGiftCardImage
                        immSteps={immSteps}
                        accountBuyAmazonGiftCard={accountBuyAmazonGiftCard}
                    />
                </div>
                <div className="accounts-buy-amazon-gift-card-success__codigo-description col-xs-7">
                    <p>
                        <FormattedText value="amazonGiftCard-successSubheader" />
                    </p>
                    <div>
                        {giftCardClaimCode}
                    </div>
                    <div className="accounts-buy-amazon-gift-card-success__codigo-link">
                        <OKLink
                            target="_blank"
                            modifier="emphasize"
                            to={CANJEAR_CODIGO_LINK}
                        >
                            <FormattedText value="amazonGiftCard-redeemText" format="uppercase" />
                        </OKLink>
                    </div>
                </div>
            </div>
        );

        return (
            <div className="accounts-buy-amazon-gift-card-success col-xs-9 center-block">
                <WizardSuccess
                    successMessage={successTitle}
                    customClassName=""
                    successSubMessage={successSubMessage}
                    mainButton={mainButton}
                    onMainButtonClick={handleVolverACuentasClick}
                >
                    <div className="wizard-success-step__separator" />
                    <div className="accounts-buy-amazon-gift-card-success__card-details">
                        <AmazonGiftCardDetails
                            immSteps={immSteps}
                            immAccounts={immAccounts}
                            columnCount={3}
                            giftVoucherAmountKey={'buyAmazonGiftCard-giftVoucherAmountLabel'}
                        />
                    </div>
                    <div className="accounts-buy-amazon-gift-card-success__steps">
                        <AmazonGiftCardReedemptionSteps
                            showHorizontalSteps={false}
                        />
                    </div>
                    {disclaimerText}
                    <div className="accounts-buy-amazon-gift-card-success__help-box">
                        <FormattedText value="amazonGiftCard-helpBoxDescription"/>
                    </div>
                </WizardSuccess>
            </div>
        );
    }
}

AccountsBuyAmazonGiftCardSuccess.propTypes = {
    accountBuyAmazonGiftCard: PropTypes.object,
    handleVolverACuentasClick: PropTypes.func,
    immSteps: PropTypes.object,
    immAccounts: PropTypes.object,
    showNotification: PropTypes.func,
}

module.exports = AccountsBuyAmazonGiftCardSuccess;

